import { createSelector } from 'reselect';

const tableSelector = (state: any) => state.get('table');
const tablesSelector = createSelector([tableSelector], stocks => stocks.get('tables').toJS());

export {
	tableSelector,
	tablesSelector,
};
